// Socket configuration chooser.
// Local dev: set REACT_APP_USE_LOCAL_SOCKET=true in .env.development.local.
// Production builds always use the production URL, even if the flag is set.

// NOTE: Hostname must match the Azure Web App name (cubesocket-linux-awa3a2c9ejdbeqc9.centralus-01.azurewebsites.net)
const PROD_SOCKET_URL =
  'https://cubesocket-linux-awa3a2c9ejdbeqc9.centralus-01.azurewebsites.net';
const DEFAULT_LOCAL_PORT = 8900;

const normalizeBool = (val) =>
  String(val || '')
    .trim()
    .toLowerCase() === 'true';

const normalizePort = (val) => {
  const n = parseInt(String(val || '').trim(), 10);
  return Number.isFinite(n) && n > 0 ? n : DEFAULT_LOCAL_PORT;
};

const isProduction = process.env.NODE_ENV === 'production';
const useLocalFlag = normalizeBool(process.env.REACT_APP_USE_LOCAL_SOCKET);
const localPort = normalizePort(process.env.REACT_APP_LOCAL_SOCKET_PORT);

const SOCKET_URL =
  isProduction || !useLocalFlag
    ? PROD_SOCKET_URL
    : `ws://localhost:${localPort}`;

console.log(
  `[socket-config] Using ${SOCKET_URL} (useLocal=${useLocalFlag}, env=${process.env.NODE_ENV})`,
);

export { SOCKET_URL };
export default SOCKET_URL;
